import { AllegatoDtoTipoDocumentoEnum, DatiAzienda } from "@api/client";
import { companyDetailsSelector } from "common/_redux/company/selectors";
import { fileUpload } from "common/_redux/file/actions";
import { praticaRiprendiSelector } from "common/_redux/pratica/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import BftDropzone from "common/components/dropzone";
import { FilesUtils } from "common/file.utils";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { Formik } from "formik";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Topbar from "layout/components/topbar";
import { FileDocument } from "models/files";
import { Col, Row } from "react-bootstrap";
import useReopenNavigate from "../hooks/reopenNavigate";

const title = "Documenti Aziendali";
const subtitle = "Allega il frontespizio del documento.";

interface InitialValues extends DatiAzienda {
	SCO_TGI?: FileDocument | undefined;
	ASS_ATC?: FileDocument | undefined;
	ASS_VRL?: FileDocument | undefined;
	ASS_API?: FileDocument | undefined;
	LIC_AUT?: FileDocument | undefined;
	CONTRATTO_UTENZA_LOCAZIONE?: FileDocument | undefined;
}

const documentiVisibili = [
	"TULPS_GIOCO",
	"ATTO_COSTITUTIVO",
	"VERBALE_RAPP_LEGALE",
	"ATTRIBUZIONE_PARTITA_IVA",
	"LIC_AUT",
	"CONTRATTO_UTENZA_LOCAZIONE",
];

const ReopenDocumentiAziendali: React.FC = () => {
	const dispatch = useAppDispatch();
	const reopenNavigate = useReopenNavigate();

	const reopenPratica = useAppSelector(praticaRiprendiSelector);

	const companyDetails = useAppSelector(companyDetailsSelector);

	const elencoAllegatiUpload = reopenPratica?.allegatiToUpload?.some(
		(e) => e.tipoDocumento && documentiVisibili.includes(e.tipoDocumento)
	);

	const navBack = () => {
		reopenNavigate?.goBack();
	};

	const goNext = () => {
		reopenNavigate?.goNext();
	};

	const _handleSubmit = (values: InitialValues) => {
		let _values = { ...values };

		let documents: (FileDocument | undefined)[] = [];

		documents.push(_values?.SCO_TGI);
		documents.push(_values?.ASS_ATC);
		documents.push(_values?.ASS_VRL);
		documents.push(_values?.ASS_API);
		documents.push(_values?.LIC_AUT);
		documents.push(_values?.CONTRATTO_UTENZA_LOCAZIONE);

		documents = documents.filter((f) => f != undefined && f?.size > 0);

		delete _values?.SCO_TGI;
		delete _values?.ASS_ATC;
		delete _values?.ASS_VRL;
		delete _values?.ASS_API;
		delete _values?.LIC_AUT;
		delete _values?.CONTRATTO_UTENZA_LOCAZIONE;

		dispatch(fileUpload(documents as FileDocument[]))
			.unwrap()
			.then((response) => {
				if (response || documents.length < 1) {
					goNext();
				}
			});
	};

	// useEffect(() => {
	// 	dispatch(companyGetCompanyDetails());
	// }, []);

	return (
		<>
			{elencoAllegatiUpload ? (
				<div className="d-flex flex-column min-vh-100">
					<div className="body flex-grow-1 px-0">
						<Header />
						<Topbar />
						<div className="container-fluid body-section px-0">
							<section>
								<Row>
									<Col sm={12} lg={8}>
										<Formik
											initialValues={{
												SCO_TGI: FilesUtils.AllegatoDtoToFileDocument(
													companyDetails?.elencoAllegati?.find(
														(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.TulpsGioco
													)
												),
												ASS_ATC: FilesUtils.AllegatoDtoToFileDocument(
													companyDetails?.elencoAllegati?.find(
														(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.AttoCostitutivo
													)
												),
												ASS_VRL: FilesUtils.AllegatoDtoToFileDocument(
													companyDetails?.elencoAllegati?.find(
														(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.VerbaleRappLegale
													)
												),
												ASS_API: FilesUtils.AllegatoDtoToFileDocument(
													companyDetails?.elencoAllegati?.find(
														(f) =>
															f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.AttribuzionePartitaIva
													)
												),
												LIC_AUT: FilesUtils.AllegatoDtoToFileDocument(
													companyDetails?.elencoAllegati?.find(
														(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.LicAut
													)
												),
												CONTRATTO_UTENZA_LOCAZIONE: FilesUtils.AllegatoDtoToFileDocument(
													companyDetails?.elencoAllegati?.find(
														(f) =>
															f.tipoDocumento ==
															AllegatoDtoTipoDocumentoEnum.ContrattoUtenzaLocazione
													)
												),
											}}
											onSubmit={_handleSubmit}
											enableReinitialize
										>
											{({ values, handleSubmit, setFieldValue, setFieldTouched }) => {
												const handleFileChange = (name: string, file?: FileDocument | null) => {
													setFieldTouched(name);
													setFieldValue(name, file);
												};

												const documenti = [
													{
														field: "SCO_TGI",
														tipoDocumento: AllegatoDtoTipoDocumentoEnum.TulpsGioco,
														label: "Tulps Gioco",
													},
													{
														field: "ASS_ATC",
														tipoDocumento: AllegatoDtoTipoDocumentoEnum.AttoCostitutivo,
														label: "Atto Costitutivo",
													},
													{
														field: "ASS_VRL",
														tipoDocumento: AllegatoDtoTipoDocumentoEnum.VerbaleRappLegale,
														label: "Verbale Rappresentante Legale",
													},
													{
														field: "ASS_API",
														tipoDocumento: AllegatoDtoTipoDocumentoEnum.AttribuzionePartitaIva,
														label: "Attribuzione Partita IVA",
													},
													{
														field: "LIC_AUT",
														tipoDocumento: AllegatoDtoTipoDocumentoEnum.LicAut,
														label: "Licenza Aut",
													},
													{
														field: "CONTRATTO_UTENZA_LOCAZIONE",
														tipoDocumento: AllegatoDtoTipoDocumentoEnum.ContrattoUtenzaLocazione,
														label: "Contratto Utenza Locazione",
													},
												];

												return (
													<form onSubmit={handleSubmit}>
														<h2 className="mb-3 ms-3">{title}</h2>
														<span className="gray">{subtitle}</span>

														<BftAccordion
															title="Allega i documenti aziendali"
															subtitle="Allega."
															index={1}
															total={1}
															isActive={true}
														>
															<div className="px-1">
																{
																	<div>
																		<Row>
																			{documenti
																				.filter((doc) => {
																					return reopenPratica?.allegatiToUpload?.some(
																						(e) =>
																							e.tipoDocumento === doc.tipoDocumento &&
																							documentiVisibili.includes(e.tipoDocumento)
																					);
																				})
																				.map((doc) => {
																					const file = values[doc.field as keyof InitialValues];

																					const fileDocument =
																						file && typeof file !== "string" && file !== true
																							? file
																							: undefined;

																					return (
																						<Col
																							md={6}
																							className="my-3 d-flex container d-flex justify-content-center flex-column"
																							key={doc.field}
																						>
																							<BftDropzone
																								label={doc.label}
																								idTipoDocumento={doc.field}
																								file={fileDocument}
																								onChange={(e) => handleFileChange(doc.field, e)}
																							/>
																						</Col>
																					);
																				})}
																		</Row>
																	</div>
																}
															</div>
														</BftAccordion>

														<Row className="justify-content-between mx-1">
															<Col xs={1}>
																<BftButton
																	className="btn-buffetti-secondary px-3"
																	onClick={() => navBack()}
																>
																	<i className="fas fa-arrow-left"></i>
																</BftButton>
															</Col>

															<Col xs={10} md={11}>
																<BftButton type="submit" className="btn-buffetti col-12">
																	Vai allo step successivo
																</BftButton>
															</Col>
														</Row>
													</form>
												);
											}}
										</Formik>
									</Col>
									<Col sm={12} md={4} className="side-card">
										<DettaglioPianoCard />
									</Col>
								</Row>
							</section>
						</div>
					</div>
					<Footer />
				</div>
			) : (
				<div className="d-flex flex-column min-vh-100">
					<div className="body flex-grow-1 px-0">
						<Header />
						<Topbar />
						<div className="container-fluid body-section px-0">
							<section>
								<Row>
									<Col sm={12} lg={8}>
										<form>
											<h2 className="mb-3 ms-3">{title}</h2>
											<span className="gray">
												Non sono presenti documenti dell'azienda da caricare, procedi allo step
												successivo.
											</span>

											<Row className="justify-content-between mx-1 mt-3">
												<Col xs={1}>
													<BftButton
														className="btn-buffetti-secondary px-3"
														onClick={() => navBack()}
													>
														<i className="fas fa-arrow-left"></i>
													</BftButton>
												</Col>

												<Col xs={10} md={11}>
													<BftButton
														type="submit"
														className="btn-buffetti col-12"
														onClick={() => goNext()}
													>
														Vai allo step dei pagamenti
													</BftButton>
												</Col>
											</Row>
										</form>
									</Col>
									<Col sm={12} md={4} className="side-card">
										<DettaglioPianoCard />
									</Col>
								</Row>
							</section>
						</div>
					</div>
					<Footer />
				</div>
			)}
		</>
	);
};

export default ReopenDocumentiAziendali;
